<h2 class="mb-0" mat-dialog-title>Reactivate Deal</h2>
<mat-dialog-content>
  <p class="tw-pt-3">Reactivating this deal will move it from inactive to its most recent active status. The dead disposition reason will also be removed from the record.</p>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer-container">
  <button mat-flat-button mat-dialog-close>Cancel</button>
  <button
    mat-raised-button
    color="primary"
    (click)="reactivateDeal()">
    Reactivate
  </button>
</mat-dialog-actions>
